//====================================================
//  Function: init scroll
//====================================================
function fn_components_side_navigation(){
	if ($('.js-menu-navigation').length){
		checkScroll();
	}
}

var	scrolling = false;
var contentSections = $('.section-scroll'),
	verticalNavigation = $('.js-menu-navigation'),
	navigationItems = verticalNavigation.find('a');

function checkScroll() {
	if( !scrolling ) {
		scrolling = true;
		(!window.requestAnimationFrame) ? setTimeout(updateSections, 300) : window.requestAnimationFrame(updateSections);
	}
}

function updateSections() {
	var halfWindowHeight = $(window).height()/2,
		scrollTop = $(window).scrollTop();
	contentSections.each(function(){
		var section = $(this),
			sectionId = section.attr('id');
			var navigationItem = navigationItems.filter('[href^="#'+ sectionId +'"]');
		if ((section.offset().top - halfWindowHeight < scrollTop ) && ( section.offset().top + section.innerHeight() - halfWindowHeight > scrollTop)) {
			// if (navigationItem)
			
			// if (navigationItem.data('scroll') == 'section-1' || navigationItem.data('scroll') == 'section-5'){
			// 	navigationItem.closest( '.side-navigation-list' ).addClass( '.side-navigation-list-brown' )
			// } else {
			// 	navigationItem.closest( '.side-navigation-list' ).removeClass( '.side-navigation-list-brown' )
			// }
			navigationItem.addClass( class_active )
		} else {
			navigationItem.removeClass( class_active );
		}
	});
	scrolling = false;
}
